




















































import { Component, Prop, Vue } from 'vue-property-decorator';

import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import CampaignStatisticsChart from '@/componentsV2/molecules/CampaignStatisticsChart/CampaignStatisticsChart.vue';
import ProgressbarInfo from '@/componentsV2/molecules/ProgressbarInfo/ProgressbarInfo.vue';
import { Campaign } from '@/models/marketingCenter/freeCoins';

import ModalOptions from '@/components/Modal/ModalOptions';
import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';

import AnalyticsService from '@/api/AnalyticsService';
import { campaignStatisticsFilter } from '@/utils/campaignStatisticsFilter';

@Component({
  components: {
    GhostButton,
    Checkbox,
    CampaignStatisticsChart,
    ProgressbarInfo
  }
})
export default class CampaignCard extends Vue {
  @Prop({ default: () => ({}) }) readonly campaign!: Campaign;

  analyticsService: AnalyticsService = new AnalyticsService();

  statistics = {
    entries: []
  };

  overallStatistics = {
    coinsClaimed: 0,
    customersClaimed: 0
  };

  get isActive() {
    return this.campaign.status === 'active';
  }

  get expirationLabel() {
    const isLimit = !!this.campaign.dateLimit;

    if (isLimit) {
      const differenceDaysCreated = DateUtils.getDifferenceDays(
        this.campaign.createdAt || '',
        this.campaign.dateLimit || ''
      );

      const differenceDaysToday = DateUtils.getDifferenceDays(
        this.campaign.createdAt || '',
        DateUtils.formatDate(new Date())
      );

      const differenceDaysTodayLimited = Math.min(
        differenceDaysToday,
        differenceDaysCreated
      );

      return {
        title: `${differenceDaysTodayLimited}/${differenceDaysCreated} days until deadline`,
        percentage: this.getPercentage(
          differenceDaysTodayLimited,
          differenceDaysCreated
        )
      };
    }

    return {
      title: 'No expiration date limit',
      percentage: 0
    };
  }

  async getCampaignStatistics() {
    const { from, to } = DateUtils.getFromAndToDates();

    if (!this.campaign.id) return;

    const response = await this.analyticsService.getCampaignStatistics(
      from,
      to,
      this.campaign.id
    );

    if (response.status === 200 && response.data.overallStatistics) {
      this.overallStatistics = {
        coinsClaimed: Number(response.data.overallStatistics.totalCoins),
        customersClaimed: Number(response.data.overallStatistics.claims)
      };

      if (response.data.dailyStatistics.items.length) {
        this.statistics = {
          ...this.statistics,
          entries: response.data.dailyStatistics.items[0].entries
        };
      }
    }
  }

  getPercentage(value1?: number | string, value2?: number | string) {
    if (!value1 && !value2) return 0;

    return ((Number(value1) / Number(value2)) * 100).toFixed(0);
  }

  onShare() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'campaignShareModal',
        false,
        true,
        true,
        true,
        true
      )
    );

    this.$analytics({
      eventCategory: 'Free Coins Campaign | Share campaign button',
      eventAction: 'click',
      eventLabel: 'Clicked on Share campaign button'
    });
  }

  triggerActivation() {
    if (!this.isActive) {
      eventBus.$emit(
        'openSubModal',
        new ModalOptions(
          ``,
          ``,
          'none',
          true,
          ``,
          ``,
          ``,
          false,
          'offerFreeCoinsConfirmModal',
          false,
          true,
          true,
          true,
          true
        ),
        {
          status: this.isActive,
          campaignId: this.campaign.id,
          hasActiveCampaign: this.isActive
        }
      );
    } else {
      eventBus.$emit('changeFreeCoinCampaignStatus', {
        status: this.isActive,
        id: this.campaign.id
      });
    }
  }

  gotoOfferDetail() {
    this.$router.push({
      path: `/marketing-center/offer-free-coins/${this.campaign.id}`,
      ...(this.campaign.createdAt && {
        query: campaignStatisticsFilter(this.campaign.createdAt)
      })
    });
  }

  mounted() {
    this.getCampaignStatistics();
  }
}
